import faqApi from 'api/requests/faq'
import Button from 'components/_UI/Button'
import Fieldset from 'components/_UI/Fieldset'
import Loader from 'components/_UI/Loader'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import TextArea from 'components/_UI/TextArea'
import { useEvent } from 'context/events/Event'
import fieldValidations from 'helpers/fieldValidations'
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'

function FaqForm({ modalFaq, setModalFaq, onSuccess, edit = false }) {
    const { event } = useEvent()
    const [loading, setLoading] = useState(false)

    const {
        register,
        reset,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            question: edit?.question,
            answer: edit?.answer
        }
    });

    function createPayload(content) {
        const payload = {
            question: content?.question,
            answer: content?.answer
        }

        return payload
    }

    async function createFaq(content) {
        setLoading(true)
        const payload = createPayload(content)

        try {
            const { data } = await faqApi.create(event.slug, payload)
            console.log(data)
            onSuccess('createFaq')
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }


    async function editFaq(content) {
        setLoading(true)
        const payload = createPayload(content)
        console.log(payload)
        try {
            const { data } = await faqApi.update(event.slug, payload, edit.id)
            console.log(data)
            onSuccess('editFaq')
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal isOpen={modalFaq} onClose={() => setModalFaq(false)}>
            <Text name='highlight'>{!edit ? 'Adicionar' : 'Atualizar'} pergunta</Text>
            <Form onSubmit={handleSubmit(!edit ? createFaq : editFaq)}>
                <Fieldset
                    label='Pergunta *'
                    placeholder='Pergunta'
                    register={register}
                    name='question'
                    layout='squired'
                    validations={fieldValidations.name('pergunta', 5, 900)}
                />
                {
                    errors?.question?.message && (
                        <Column>
                            <Text color={colors.danger} name='small'> {errors.question.message} </Text>
                        </Column>
                    )
                }

                <ContentTexArea>
                    <Text paddingBottom="5px">Resposta *</Text>
                    <Column>
                        <Controller
                            name="answer"
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <TextArea
                                        {...field}
                                        placeholder="Resposta"
                                        register={register}
                                        name={'answer'}
                                        squired
                                        validations={fieldValidations.name('resposta', 5, 1200)}
                                    />


                                    {errors.answer?.message && (
                                        <Column name="small" color={colors.danger} marginTop='8px'>
                                            <Text color={colors.danger} name='small'> {errors.answer.message} </Text>
                                        </Column>
                                    )}

                                </>
                            )}
                        />
                    </Column>
                </ContentTexArea>

                {
                    loading ? (
                        <Loader />
                    ) : (
                        <ContentButton>
                            <Button
                                variant={'light'}
                                category={'roundedBorded'}
                                onClick={() => setModalFaq(false)}
                            >
                                Cancelar
                            </Button>
                            <Button variant='featured' type={'submit'}>
                                {!edit ? 'Adicionar' : 'Atualizar'}
                            </Button>
                        </ContentButton>
                    )
                }
            </Form>
        </Modal>
    )
}

export default FaqForm


const Form = styled.form`
    width: 100%;
`;

const ContentButton = styled(Column)`
    margin-top: 15px;
    @media screen and (min-width: ${breakpoints.md}){
        flex-direction: row;
        gap: 5px;
    }
    
`;


const ContentTexArea = styled(Column)`
    width: 100%;
    align-items: flex-start;

    & > p {
        font-size: 12px;
        font-weight: 600;
        color: ${colors.nightDark} !important;
    }
`

